<template>
  <NoStuffPlaceholder
    :display="display"
    heading="POS.SHOP_SETTINGS.STARTPAGE.PRODUCT_PREVIEW.EMPTY.HEADING"
    sub-heading="POS.SHOP_SETTINGS.STARTPAGE.PRODUCT_PREVIEW.EMPTY.SUBHEADING"
    faq="POS.SHOP_SETTINGS.STARTPAGE.COLLECTION_PREVIEW.EMPTY.FAQ"
    :faq-link="faqLink"
    cta-icon="shirt"
    cta-text="POS.SHOP_SETTINGS.STARTPAGE.PRODUCT_PREVIEW.EMPTY.LINK_UPLOAD"
    cta-target="partnerarea.shop.publishing"
  />
</template>

<script>
import NoStuffPlaceholder from 'src/app/partnerarea/pos/shop/common/NoStuffPlaceholder.vue';
import smartFaqLinks from 'commons/smartFaq/smartFaqLinks';
import { StartPageData } from 'src/app/partnerarea/pos/shop/shopSavable/StartPageData';

export default {
  name: 'NoProductPreviewPlaceholder',
  components: {
    NoStuffPlaceholder,
  },
  mixins: [StartPageData],
  data() {
    return {
      faqLink: smartFaqLinks.IDEA_CREATION_HELP,
    };
  },
  computed: {
    display() {
      const { productPreviewPossible } = this.startPage;
      return (
        typeof productPreviewPossible === 'boolean' && !productPreviewPossible
      );
    },
  },
};
</script>
